import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TroubleSignupDTO } from '../../core/models/troublesignup.modal';
import { UserService } from '../../core/services/user.service';

@Component({
  selector: 'app-trouble-signup',
  templateUrl: './trouble-signup.component.html',
  styleUrls: ['./trouble-signup.component.scss'],
})
export class TroubleSignupComponent {
  troubleSignupDTO = new TroubleSignupDTO();
  isSubmitting = false;
  submitted = false;
  successMessage = '';
  errorMessage = '';

  constructor(private userService: UserService) {}

  submit(form: NgForm): void {
    this.submitted = true;
    this.successMessage = '';
    this.errorMessage = '';

    if (form.invalid || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.userService.troubleSignup(this.troubleSignupDTO).subscribe({
      next: (res: any) => {
        this.isSubmitting = false;

        if (res?.success === 0) {
          this.successMessage =
            'Thanks — we received your request and will be in touch.';
          this.troubleSignupDTO = new TroubleSignupDTO();
          form.resetForm(this.troubleSignupDTO);
          this.submitted = false;
          return;
        }

        this.errorMessage =
          res?.message || 'We could not send your request. Please try again.';
      },
      error: (error: any) => {
        this.isSubmitting = false;
        this.errorMessage =
          error?.message || 'We could not send your request. Please try again.';
      },
    });
  }
}
